import React from "react";

import styles from "./FeedbackTopBanner.module.scss";

export const FeedbackTopBanner = ({ title, subtitle }) => {
  return (
    <div className={styles.containerWrapper}>
      <div className={styles.container}>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>
    </div>
  );
};
